<p-breadcrumb
  [model]="[
    { label: 'Frequências', routerLink: ['/payment-frequencies'] },
    {
      label: paymentFrequenceId() ? 'Editar Frequência' : 'Nova Frequência',
      routerLink: paymentFrequenceId()
        ? ['/payment-frequencies/update/' + paymentFrequenceId()]
        : ['/payment-frequencies/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(paymentFrequenceId()){
        <h5 class="font-bold">Editar Frequência</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Nova Frequência</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if(paymentFrequenceId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/payment-frequencies"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="w-full">
      <label for="name"> Nome *</label>
      <input
        pInputText
        type="text"
        formControlName="name"
        class="w-full"
        placeholder="Ex: Diário, Semanal, Quinzenal, Mensal..."
      />
      <app-form-error [control]="formGroup.get('name')" />
      <app-form-server-error [control]="formGroup.get('name')" />
    </div>

    <div class="w-full">
      <label for="intervalInDays"> Intervalo em dias *</label>
      <p-inputNumber
        formControlName="intervalInDays"
        inputId="intervalInDays"
        [min]="1"
        class="w-full"
        placeholder="Ex: 7, 15, 30..."
      ></p-inputNumber>
      <app-form-error [control]="formGroup.get('intervalInDays')" />
      <app-form-server-error [control]="formGroup.get('intervalInDays')" />
    </div>

    <div class="w-full">
      <label for="description"> Descrição</label>
      <input
        pInputText
        type="text"
        formControlName="description"
        class="w-full"
        placeholder="Informe a descrição"
      />
      <app-form-error [control]="formGroup.get('description')" />
      <app-form-server-error [control]="formGroup.get('description')" />
    </div>
  </div>

  @if(loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>
